export default __webpack_public_path__ + "static/media/creditterm.d9d0475a.png";